export default __webpack_public_path__ + "static/media/Payroll.1f214dce.svg";